import { Action } from '@ngrx/store';

export const CHANGE_PASSWORD = '[Security] Change Password';

export class ChangePasswordAction implements Action {
  readonly type = CHANGE_PASSWORD;
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/ChangePasswordAction.ts